import React, { useEffect, useState } from 'react';
import { PlaySquareOutlined, UploadOutlined } from '@ant-design/icons';
import { Alert, Divider, Form, Input, Switch, Upload } from 'antd';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { API_BASE_URL, ASSET_BASE_URL } from '../../../../configs/AppConfig';

export default {
    Renderer: (props) => {
        const data = props.data

        const [loaded, setLoaded] = useState(false)
        useEffect(() => {
            setLoaded(true)
        }, [])

        if (!loaded) {
            return null
        }

        return (
            <div style={{ width: "100%", height: "inherit" }}>
                {data.video && (
                    <video
                        muted={data.autoPlay}
                        autoPlay={data.autoPlay}
                        controls
                        src={data.video}
                        style={{ width: "100%", height: "inherit", backgroundColor: "#000" }}
                    />
                )}

                {!data.video && (
                    <Alert showIcon type={"warning"} message={t`Veuillez télécharger une video.`} />
                )}
            </div>
        )

    },
    id: 'video-viewer',
    title: t`Video`,
    description: t`Intégrez votre video mp4`,
    icon: <PlaySquareOutlined />,
    version: 1,
    controls: {
        type: 'custom',
        Component: Controls
    }
}

function Controls(props) {

    const { data, onChange } = props

    const [show, setShow] = useState(true)
    const refreshForm = () => {
        setShow(false)
        setTimeout(() => setShow(true), 100)
    }
    useEffect(() => {
        refreshForm()
    }, [props.lang, props.nodeId, props.device])

    if (!show) {
        return null
    }

    return (
        <div>
            <Upload.Dragger
                style={{ width: "100%" }}
                type={"select"}
                maxCount={1}
                multiple={false}
                accept="video/*"
                showUploadList={false}
                headers={{ authorization: localStorage.getItem("AUTH_TOKEN") }}
                action={API_BASE_URL + "/upload/video?autoValide=1"}
                onChange={({ file }) => {
                    if (file.response && file.status === "done") {
                        const url = ASSET_BASE_URL + "/" + file.response
                        onChange({ video: url })
                    }
                }}
            >
                <p className="ant-upload-drag-icon">
                    <UploadOutlined />
                </p>
                <p className="ant-upload-text">
                    <Trans>Cliquez ou déposez votre fichier Video</Trans>
                </p>
            </Upload.Dragger>

            <Divider><Trans>Ou</Trans></Divider>

            <Form.Item label={<Trans>Url</Trans>}>
                <Input
                    placeholder={t`Url de la video`}
                    type="url"
                    value={data.video}
                    onChange={(e) => onChange({ video: e.target.value })}
                />
            </Form.Item>

            <Divider><Trans>Options</Trans></Divider>

            <Form.Item label={<Trans>Lecture automatique</Trans>}>
                <Switch checked={data.autoPlay} onChange={(bool) => onChange({ autoPlay: bool })} />
            </Form.Item>
        </div>
    )
}
